/**
 * Holder Data Loader
 *
 * Gestisce il caricamento e l'estrazione dei dati degli intestatari
 * per il blocco sidebar-bill-to-pax
 */

/**
 * Trova il titolare del credito welfare dalla lista dei beneficiari
 *
 * @param {Array} beneficiaries - Lista dei beneficiari dall'API
 * @returns {Object|null} - Il beneficiario con relation === 'me'
 */
export function find_welfare_holder(beneficiaries) {
  if (!beneficiaries || beneficiaries.length === 0) {
    return null
  }

  return beneficiaries.find(b => b.relation === 'me') || null
}

/**
 * Trova un beneficiario nella lista per ID
 *
 * @param {Array} beneficiaries - Lista dei beneficiari dall'API
 * @param {String} id - ID del beneficiario da cercare
 * @returns {Object|null} - Il beneficiario trovato o null
 */
export function find_beneficiary_by_id(beneficiaries, id) {
  return (beneficiaries || []).find((b) => String(b.id) === String(id)) || null;
}

/**
 * Svuota il codice fiscale dei beneficiari che hanno lo stesso CF del titolare welfare.
 * Il backend copia il CF del titolare su tutti i beneficiari: questa funzione corregge
 * quel comportamento per permettere l'inserimento manuale del CF corretto.
 *
 * @param {Array} beneficiaries - Lista dei beneficiari dall'API
 * @returns {Array} - Nuova lista con i CF duplicati svuotati
 */
export function clean_copied_fiscal_codes(beneficiaries) {
  const holder = find_welfare_holder(beneficiaries)
  if (!holder || !holder.fiscalCode) return beneficiaries

  return beneficiaries.map(b => {
    if (b.relation !== 'me' && b.fiscalCode === holder.fiscalCode) {
      return { ...b, fiscalCode: '' }
    }
    return b
  })
}

/**
 * Estrae i dati per precompilare il form dall'oggetto sorgente (beneficiary/holder)
 * Usata per tutti i casi: welfare, traveler, other (senza parametro per form vuoto)
 *
 * @param {Object} source - Oggetto sorgente con { name, surname, fiscalCode }
 * @returns {Object} - Dati per il form { firstName, lastName, fiscalCode }
 */
export function extract_holder_form_data(source) {
  return {
    firstName: (source && source.name) || '',
    lastName: (source && source.surname) || '',
    fiscalCode: (source && source.fiscalCode) || ''
  }
}